export default "<div class=\"dropdown-link-wrap\" (click)=\"toggleDropdown()\">\n  <ng-content></ng-content>\n</div>\n"